<template>
  <div>
    <br />
    <div>
      <img alt="Logo" src="../assets/AGTEALCROPPED.png" width="120" height="120" />
    </div>
    <!-- <div v-if="this.ParentCompany == 'Angel Guard'">
      <img alt="Logo" src="../assets/AGTEALCROPPED.png" width="120" height="120" />
    </div>
    <div v-if="this.ParentCompany == ''">
      <img alt="Logo" src="../assets/AGTEALCROPPED.png" width="120" height="120" />
    </div>
    <div v-if="this.ParentCompany == 'Hydro-X'">
      <img alt="Logo" src="../assets/CompanyLogos/HydroXLogo.png" />
    </div>
    <div v-if="this.ParentCompany == 'Galvin Engineering'">
      <img
        alt="Logo"
        src="../assets/CompanyLogos/GalvinLogoNoBack.png"
        height="100"
        width="100"
      />
    </div>
    <div v-if="this.ParentCompany == '361 Degrees'">
      <img
        alt="Logo"
        src="https://c.yell.com/t_bigRect,f_auto/711caa05-4481-4bfc-a908-9d832f3ec67f_image_png.png"
        width="150"
      />
    </div>

    <div v-if="this.ParentCompany == 'Marlowe'">
      <img alt="Logo" src="../assets/CompanyLogos/MarloweLogoResize.png" />
    </div> -->
  </div>
</template>
<script>
export default {
  computed: {},
  components: {},

  data() {
    return {
      ParentCompany: localStorage.getItem("ParentCompany"),
    };
  },

  beforeMount() {},

  mounted() {},
};
</script>
<style scoped></style>
